export default class QuadEdgeLocator {
  locate(v) {}
}
